(function () {
  'use strict';

  async function loadGuide(root, overlay) {
    const url = root.dataset.url;
    const content = overlay.querySelector('[data-mr-size-guide-content]');
    const loader = overlay.querySelector('[data-mr-size-guide-loader]');

    if (!url || !content || content.dataset.loaded === 'true') return;

    try {
      if (loader) loader.hidden = false;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Failed to load size guide');
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const main =
        doc.querySelector('main') ||
        doc.querySelector('#MainContent') ||
        doc.body;

      content.innerHTML = main.innerHTML;
      content.dataset.loaded = 'true';

      content.querySelectorAll('script').forEach((oldScript) => {
        const newScript = document.createElement('script');

        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });

        newScript.text = oldScript.textContent;
        oldScript.replaceWith(newScript);
      });
    } catch (error) {
      content.innerHTML = '<p>Size guide could not be loaded.</p>';
      console.error(error);
    } finally {
      if (loader) loader.hidden = true;
    }
  }

  function getOverlay(root) {
    let overlayId = root.dataset.overlayId;

    if (overlayId) {
      return document.getElementById(overlayId);
    }

    const overlay = root.querySelector('[data-mr-size-guide-overlay]');
    if (!overlay) return null;

    overlayId = 'mr-size-guide-' + Math.random().toString(36).slice(2);

    overlay.id = overlayId;
    root.dataset.overlayId = overlayId;

    document.body.appendChild(overlay);

    return overlay;
  }

  function openGuide(root) {
    const overlay = getOverlay(root);
    if (!overlay) return;

    overlay.hidden = false;

    document.body.classList.add('mr-size-guide-open');

    loadGuide(root, overlay);
  }

  function closeGuide(overlay) {
    if (!overlay) return;

    overlay.hidden = true;

    document.body.classList.remove('mr-size-guide-open');
  }

  document.addEventListener(
    'click',
    function (event) {
      const openBtn = event.target.closest('[data-mr-size-guide-open]');
      const closeBtn = event.target.closest('[data-mr-size-guide-close]');

      if (openBtn) {
        event.preventDefault();
        event.stopPropagation();

        const root = openBtn.closest('[data-mr-size-guide]');

        if (root) {
          openGuide(root);
        }

        return;
      }

      if (closeBtn) {
        event.preventDefault();
        event.stopPropagation();

        const overlay = closeBtn.closest('[data-mr-size-guide-overlay]');

        closeGuide(overlay);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-mr-size-guide-overlay]').forEach((overlay) => {
      closeGuide(overlay);
    });
  });
})();